"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _dialog2;
var _default = exports.default = {
  otherControlledFile: {
    qualityFile: {
      rules: {
        orderNum: '最多输入12位整数,5位小数'
      },
      vesselControlledFile: '体系管理',
      otherControlledFile: '支持性文件',
      controlledFile: '支持性文件维护',
      otherControlledDocuments: '文件目录',
      fileNo: '文件编号',
      fileName: '文件名称',
      enterFileNo: '请输入文件编号',
      enterFileName: '请输入文件名称',
      fileInformation: '文件信息',
      recordInformation: '记录信息',
      historicalVersion: '历史版本',
      linkFile: '链接文件',
      addLinkFile: '新增链接文件',
      updateLinkFile: '更新增链接文件',
      filter: {
        manageCompany: '管理公司',
        vessel: '涉及船舶',
        dept: '编制部门',
        uploadDate: '上传日期',
        yes: '是',
        no: '否',
        examination: '是否涉及考试',
        async: '船岸同步',
        isValid: '是否有效',
        status: '状态',
        valid: '有效',
        invalid: '无效'
      },
      button: {
        editCatalog: '目录维护',
        editVersion: '版本维护',
        addQualityFile: '新增文件',
        queryQualityFile: '查询文件',
        editQualityFile: '文件换版',
        editCatalogHistory: '体系变更记录',
        btnPublish: '发布',
        fileSearch: '文件搜索',
        addLinkFile: '新增链接文件'
      },
      table: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
        linkUrl: '链接地址',
        dispOrder: '显示顺序',
        qualityFileNo: '文件编号',
        qualityFileName: '文件名称',
        qualityFileType: '文件类型',
        qualityFileStatus: '状态',
        qualityFileDate: '生效日期',
        learnDeadline: '学习完成日期',
        learnDetail: '学习情况',
        feedbackDeadline: '落实完成日期',
        uploadAttach: '是否要求上传附件',
        actual: '落实情况',
        attachmentsInfoId: '相关附件',
        timeChoose: '时间选择',
        vessel: '涉及船舶',
        dept: '编制部门',
        responsibleDepartment: '责任部门',
        qualityVersion: '版本号',
        async: '是否船岸同步',
        examination: '是否涉及考试',
        mainBody: '正文',
        fileOrLink: '正文/链接'
      }, "attachmentsInfoId", '附件'), "uploader", '上传人'), "uploadDate", '上传日期'), "fileStatus", '状态'),
      dialog: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
        dispOrder: '显示顺序',
        company: '公司',
        qualityFileNo: '文件编号',
        qualityFileNoCn: '文件编号(中文)',
        qualityFileNameCn: '中文名称',
        qualityFileNameEn: '英文名称',
        qualityVersion: '版本号',
        vesselCode: '涉及船舶',
        linkUrl: '链接地址',
        responsibleDepartment: '责任部门',
        syncFlag: '是否船岸同步',
        sync: '同步',
        unSync: '不同步',
        exam: '需要',
        unExam: '不需要',
        effectiveFlag: '是否有效',
        effective: '有效',
        unEffective: '失效',
        overdueDate: '失效日期',
        selectOverdueDate: '请选择失效日期',
        relaxQualityFile: '关联文件',
        mainBody: '正文',
        upMainBody: '上传正文',
        attachmentsInfoId: '附件',
        uploadAttachment: '上传附件',
        catalog: '分类',
        sysPostId: '船端学习岗位',
        examFlag: '是否需要考试',
        companyName: '所属公司',
        enterCompany: '请选择所属公司',
        catalogName: ' 目录名称 ',
        lastModifyTime: '更新日期',
        catalogRemark: '备注',
        parentName: ' 上级目录 ',
        catalogNameCn: '目录中文名称',
        catalogNameEn: '目录英文名称'
      }, "dispOrder", '显示顺序'), "editCatalogItem", '体系目录'), "usedScope", '适用范围'), "usedShore", '岸端适用'), "vesselShoreUsed", '船岸适用'), "vesselUsed", '船端适用'), "qualityCatalog", '文件目录'), "uploadLt", '文件大小不能超过20M'), "uploadPdf", '只能上传.pdf格式文件')
    },
    qualityRecord: {
      vesselControlledFile: '体系管理',
      qualityRecord: '非体系表格维护',
      fileInformation: '文件信息',
      recordInformation: '记录信息',
      historicalVersion: '历史版本',
      filter: {
        fileNo: '编号',
        fileNoName: '文件编号/名称',
        enterFileNo: '请输入编号',
        fileName: '名称',
        enterFileName: '请输入名称',
        manageCompany: '管理公司',
        dept: '编制部门',
        involveDept: '涉及部门',
        role: '涉及岗位',
        deptMonitor: '监控部门',
        roleMonitor: '监控岗位',
        circleWork: '周期性工作',
        syncFlag: '船岸同步',
        yes: '是',
        no: '否'
      },
      table: {
        qualityRecordNo: '记录编号',
        qualityRecordName: '名称',
        qualityRecordNameCn: '名称(中文)',
        qualityRecordNameEn: '名称(英文)',
        qualityRecordVersion: '版本号',
        qualityReviseVersion: '修订版本号',
        qualityFileStatus: '状态',
        qualityRecordDate: '生效日期',
        sysPostId: '涉及岗位',
        validFlag: '状态',
        recordLocation: '存放地点',
        recordSaveTime: '保存期限',
        attachmentsName: '所属文件',
        index: '序号',
        qualityFileName: '名称',
        qualityFileDate: '生效日期',
        qualityDueDate: '失效日期'
      },
      dialog: (_dialog2 = {
        addTitle: '新增表格',
        editTitle: '编辑表格',
        queryTitle: '查看表格',
        circleFlag: '周期性提醒',
        recordRootId: '记录标识',
        qualityRecordNo: '记录编号',
        qualityRecordVersion: '版本号',
        qualityReviseVersion: '修订版本号',
        qualityRecordNameCn: '记录中文名称',
        qualityRecordNameEn: '记录英文名称',
        qualityRecordDate: '生效日期',
        recordSaveTime: '保存期限',
        syncFLag: '是否船岸同步',
        qualityRecordDept: '编制部门',
        sysOrgId: '涉及部门',
        yes: '是',
        no: '否'
      }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_dialog2, "qualityRecordDate", '生效日期'), "qualityFileId", '所属文件'), "inputCircle", '填报周期'), "createOffice", '编制部门'), "monitorPost", '监控岗位'), "startPost", '发起岗位'), "remindDate", '填报提醒'), "circleFlag", '周期性提醒'), "monitorRemind", '监控提醒'), "tableTemplate", '表格模板'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_dialog2, "sysPostId", '涉及岗位'), "recordLocation", '存放地点'), "uploadAttachment", '上传文件'), "day", '天'), "vessel", '涉及船舶'), "relatedFileType", '所属文件类型'), "qualityFile", '体系文件'), "supportFile", '支持性文件'), "rulesCirculars", '通告与法规'))
    }
  }
};